import { FC } from 'react';
import { Button, Skeleton } from 'antd';
import BillableHours from './BillableHours';
import YouVsTeamAverage from './YouVsTeamAverage';
import PeriodPicker, { PeriodRange } from './PeriodPicker';
import PeriodShiftButtons from '../PeriodShiftButtons';
import { useUserPerformance } from './useUserPerformance';
import styles from './overview.module.less';

interface OverviewProps {
  userUuid?: string;
  period: PeriodRange | null;
  onPeriodChange: (range: PeriodRange | null) => void;
}

const Overview: FC<OverviewProps> = ({ userUuid, period, onPeriodChange }) => {
  const [state, reload] = useUserPerformance({ userUuid, period });

  const renderContent = () => {
    switch (state.status) {
      case 'loading':
        return (
          <div className={styles.cardsRow}>
            <div className={`${styles.card} ${styles.billableCard}`}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
            <div className={`${styles.card} ${styles.teamCard}`}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          </div>
        );

      case 'error':
        return (
          <div className={styles.stateMessage}>
            <span>Could not load the overview.</span>
            <Button type="primary" onClick={reload}>
              Try again
            </Button>
          </div>
        );

      case 'success':
        return (
          <div className={styles.cardsRow}>
            <BillableHours data={state.data.billableHours} />
            <YouVsTeamAverage indicators={state.data.indicators} />
          </div>
        );

      default:
        return <div className={styles.stateMessage}>No data available for the selected period.</div>;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>Overview</span>
        <div className={styles.filter}>
          <PeriodShiftButtons dateRange={period} onDateRangeChange={onPeriodChange} />
          <PeriodPicker value={period} onChange={onPeriodChange} />
        </div>
      </div>

      {renderContent()}
    </div>
  );
};

export default Overview;
